"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserInfo = void 0;

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var getUserInfo = function getUserInfo() {
  return (0, _userInfo.default)();
};

exports.getUserInfo = getUserInfo;